import React, { Component } from 'react'

export default class Alert extends Component {
    render() {
        const { title, items = [], children, type = "SUCCESS", leftButton = false } = this.props;
        var typeStyle = styles.success;
        switch(type.toUpperCase()) {
            case "WARNING":
                typeStyle = styles.warning;
                break;
            case "DANGER": 
                typeStyle = styles.danger;
                break;
        }
        const newStyle = {...styles.container, ...typeStyle};
        return (
            <div style={newStyle}>
                <div style={styles.title} className="title">{title}</div>
                <div style={styles.contentHolder}>
                    <div>
                        {leftButton}
                    </div>
                    <div>
                        {children}
                        <ul style={styles.ul}>
                            {
                                items.map((item, i) => {
                                    if(item)
                                        return <li key={i} style={styles.li}>{item}</li>
                                })
                            }
                        </ul>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    container: {
        textAlign: "center",
        margin: ".5rem auto",
        padding: "1.15vh .5vw 1.5vh",
        width: "90%",
        maxWidth: "650px",
        minWidth: "350px",
    },
    contentHolder: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-evenly",
    },
    warning: {
        borderLeft: "7.5px solid #EAAF17",
        color: "#5B5346",
        background: "#F9F6EF",
    },
    success: {
        borderLeft: "7.5px solid rgb(123, 221, 25)",
        color: "rgb(70, 120, 68)",
        background: "rgb(242, 255, 233)",
    },
    danger: {
        borderLeft: "7.5px solid rgb(221, 25, 25)",
        color: "rgb(120, 68, 68)",
        background: "rgb(255, 241, 241)",
    },
    title: {
        fontSize: "1.5rem",
        margin: "0",
    },
    ul: {
        margin: "0"
    },
    li: {
        fontSize: "1.05rem"
    }
}